<template>
  <div class="calendar">
    <div ref="Tbodys" class="schedule" :style="scheduleStyle"></div>
    <table class="calendar-table">
      <thead class="calendar-head">
        <tr>
          <th rowspan="8" class="week-td">星期/时间</th>
          <th colspan="24">00:00 - 12:00</th>
          <th colspan="24">12:00 - 24:00</th>
        </tr>
        <tr>
          <td colspan="2" v-for="i in 24" :key="i">{{ Number(i-1) }}</td>
        </tr>
      </thead>
      <tbody class="calendar-body">
        <tr>
          <td>星期一</td>
          <td
            ref="calendarTd"
            class="calendar-time"
            @click="itemClick"
            colspan="2"
            v-for="i in 24"
            :key="'0,' + Number(i-1)"
            :data-id="'0,' + Number(i-1)"
          ></td>
        </tr>
        <tr>
          <td>星期二</td>
          <td
            ref="calendarTd"
            class="calendar-time"
            @click="itemClick"
            colspan="2"
            v-for="i in 24"
            :key="'1,' + Number(i-1)"
            :data-id="'1,' + Number(i-1)"
          ></td>
        </tr>
        <tr>
          <td>星期三</td>

          <td
            ref="calendarTd"
            class="calendar-time"
            @click="itemClick"
            colspan="2"
            v-for="i in 24"
            :key="'2,' + Number(i-1)"
            :data-id="'2,' + Number(i-1)"
          ></td>
        </tr>
        <tr>
          <td>星期四</td>
          <td
            ref="calendarTd"
            class="calendar-time"
            @click="itemClick"
            v-for="i in 24"
            colspan="2"
            :key="'3,' + Number(i-1)"
            :data-id="'3,' + Number(i-1)"
          ></td>
        </tr>
        <tr>
          <td>星期五</td>
          <td
            ref="calendarTd"
            class="calendar-time"
            @click="itemClick"
            v-for="i in 24"
            colspan="2"
            :key="'4,' + Number(i-1)"
            :data-id="'4,' + Number(i-1)"
          ></td>
        </tr>
        <tr>
          <td>星期六</td>
          <td
            ref="calendarTd"
            class="calendar-time"
            @click="itemClick"
            v-for="i in 24"
            colspan="2"
            :key="'5,' + Number(i-1)"
            :data-id="'5,' + Number(i-1)"
          ></td>
        </tr>
        <tr>
          <td>星期日</td>
          <td
            ref="calendarTd"
            class="calendar-time"
            @click="itemClick"
            v-for="i in 24"
            colspan="2"
            :key="'6,' + Number(i-1)"
            :data-id="'6,' + Number(i-1)"
          ></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "calendar-table",
  data() {
    return {
      left: 0,
      top: 0,
      clientX: 0,
      clientY: 0,
      isMousedown: false, // 为true时，才出发mousemove
      scheduleStyle: {},
      dateTime: [],
      viewDateArr: [],
      oldArr: [],
      domPoction: null,
    };
  },
  props: {
    hourlyPerWeek: {
      type: Array,
      default: [],
    },
  },
  created() {},
  mounted() {
    this.showHourlyData();
  },
  //监听
  watch: {
    dateTime(val) {
      let viewDate = {};
      let viewDateArr = new Array(7);
      val.map((e) => {
        let arr = e.split(",");
        if (!viewDate.hasOwnProperty(arr[0])) {
          viewDate[arr[0]] = [arr[0], Number(arr[1])];
        } else {
          if (!viewDate[arr[0]].includes(Number(arr[1]))) {
            viewDate[arr[0]].push(Number(arr[1]));
          }
        }
      });
      let dataArr = Object.keys(viewDate).map((k) => viewDate[k]);
      for (let i = 0; i < 7; i++) {
        let flag = false;
        for (let j = 0; j < dataArr.length; j++) {
          if (i == Number(dataArr[j][0])) {
            dataArr[j].splice(0, 1);
            viewDateArr[i] = dataArr[j];
            flag = true;
            break;
          }
        }
        if (!flag) {
          viewDateArr[i] = [];
        } else {
          viewDateArr[i].sort((a, b) => Number(a) - Number(b));
        }
      }
      this.viewDateArr = viewDateArr;
    },
  },
  methods: {
      showHourlyData() {
        if (this.hourlyPerWeek.length == 0) {
          return;
        }
        let calendarTdList = this.$refs.calendarTd;
        for (let i = 0; i < 7; i++) {
          for (let j = 0; j < 24; j++) {
            if (this.hourlyPerWeek[i].length > 0)
              this.hourlyPerWeek[i].forEach((k) => {
                calendarTdList[i * 24 + k].classList.add("bg");
              });
          }
        }
    },
    //点击事件
    itemClick(e) {
      e.preventDefault();
      let dom = e.target;
      //获取class
      let calendarTdList = this.$refs.calendarTd;
      let classListData = Array.from(e.target.classList);
      let timeId = dom.getAttribute("data-id");
      if (classListData.includes("bg")) {
        //选择取消高亮
        dom.classList.remove("bg");
        // this.dateTime = this.dateTime.filter((e) => {
        //   return e !== timeId;
        // });
      } else {
        //添加高亮
        dom.classList.add("bg");
        // this.dateTime.push(timeId);
      }
      let dateArr = [[], [], [], [], [], [], []];
      for (let i = 0; i < 168; i++) {
        if (calendarTdList[i].classList.contains("bg")) {
          let j = parseInt(i / 24);
          let k = i % 24;
          dateArr[j].push(k);
        }
      }
      //  this.viewDateArr=dateArr;
      this.$emit("onChange", { viewDate: dateArr });
    },
    onMousemove(e) {
      e.preventDefault();
      const { clientX, clientY } = e;
      if (this.isMousedown) {
        //
        let left = this.left,
          top = this.top,
          width = 0,
          height = 0;
        //判断滑动方向
        width = clientX - this.clientX;
        height = clientY - this.clientY;
        //x轴向左
        if (clientX < this.clientX) {
          width = this.clientX - clientX;
          left = this.left - width;
        }
        if (clientY < this.clientY) {
          height = this.clientY - clientY;
          top = this.top - height;
        }
        this.scheduleStyle = {
          width: `${width}px`,
          height: `${height}px`,
          display: "block",
          opacity: 0.6,
          left: `${left}px`,
          top: `${top}px`,
        };
      }
    },
    // 鼠标按下事件
    onMousedown(e) {
      e.preventDefault();
      this.isMousedown = true;
      const { clientX, clientY } = e;
      this.left = e.pageX; //是目标点距离document最左上角的X轴坐标
      this.top = e.pageY; //是目标点距离document最左上角的Y轴坐标
      this.clientX = clientX; //是目标点距离浏览器可视范围的X轴坐标
      this.clientY = clientY; //是目标点距离浏览器可视范围的Y轴坐标
      //判断滑动方向
      this.scheduleStyle = {
        width: `0px`,
        height: `0px`,
        display: "block",
        opacity: 0.6,
        left: `${clientX}px`,
        top: `${clientY}px`,
      };
    },
    onMouseup(e) {
      e.preventDefault();
      this.isMousedown = false;
      this.oldArr = this.dateTime;
      this.scheduleStyle = {
        width: `0px`,
        height: `0px`,
        display: "none",
        opacity: 0,
      };
      //getBoundingClientRect
      //节点位置
      this.domPoction = this.$refs.Tbody.getBoundingClientRect();
      let time = document.querySelectorAll(".calendar-time");
      //位置对比
      Array.from(time).forEach((ele) => {
        let itemPoction = ele.getBoundingClientRect();
        if (
          itemPoction.top + 10 - this.domPoction.top >= 0 &&
          this.domPoction.bottom + 10 - itemPoction.bottom >= 0 &&
          itemPoction.left + 5 - this.domPoction.left >= 0 &&
          this.domPoction.right + 5 - itemPoction.right >= 0
        ) {
          //在范围内的节点进行操作
          let timeId = ele.getAttribute("data-id");
          if (!this.dateTime.includes(timeId)) {
            ele.classList.add("bg");
            this.dateTime.push(timeId);
          } else {
            ele.classList.remove("bg");
            this.dateTime = this.dateTime.filter((i) => i !== timeId);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
table {
  border-spacing: 0;
}
.calendar {
  //   background-color: #fff;
  //   position: relative;
  //   display: inline-block;
  display: flex;
  justify-content: center;
  .schedule {
    position: fixed;
    width: 0;
    height: 0;
    top: 0;
    left: 0;
    display: block;
    background: #2f88ff;
    pointer-events: none;
  }
  .calendar-table {
    border-collapse: collapse;
    border-radius: 4px;
    td,
    th {
      border: 1px solid #e4e9ed;
      font-size: 12px;
      text-align: center;
      min-width: 25px;
      height: 35px;
    }
    thead {
      th,
      td {
        background: #f8f9fa;
      }
    }
    .calendar-body {
      background-color: #fff;
      tr {
        td {
          //   border: 1px solid #e4e9ed;
          &:hover {
            cursor: pointer;
            background-color: #E6E7E8;
          }

          &.selected {
            background-color: #2392FC;
          }
        }

        & > td:first-child {
          background-color: #f8f9fa;
        }
      }
    }
  }
}

td::selection {
  background: rgba(0, 0, 0, 0);
}

th::selection {
  background: rgba(0, 0, 0, 0);
}
.bg {
  background: #2392FC;
}
</style>